import { isEmpty } from 'lodash';

function removeMask(value) {
  return isEmpty(value) ? value : value.replace(/\D+/g, '');
}

export function removeMaskFromEvent({ target: { value } }) {
  return removeMask(value);
}

export function removePlateMask(value) {
  return isEmpty(value) ? value : value.replace(/-/g, '');
}

export default removeMask;
